import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
import { ModalDirective, BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { GeneralService } from 'src/app/services/general.service';
import { UnitsAttributesService } from 'src/app/services/units-attributes.service';
import { CategoryService } from 'src/app/services/category.service';
import { ToastrService } from 'ngx-toastr';
import { StoreService } from 'src/app/services/stores.service';
import { IStore, ICategory, IUnitsAttribute, IPricingCategory,IUnitLevelAmenitiesModel } from 'src/app/Shared/interface';
import {
    INearestLocation, IProspectUnitTypeModel, IProspectUnitList, IProspectUnitSearchList,
    IFacilityReservationSettings, IProspectUnitInfo
} from 'src/app/Shared/models/ProspectModel';
import { DatePipe } from '@angular/common';
import { UserSessionService } from 'src/app/services/usersession.service';
import { EmitType } from '@syncfusion/ej2-base';
import { FilteringEventArgs } from '@syncfusion/ej2-angular-dropdowns';
import { Query } from '@syncfusion/ej2-data';
import { StoreInfoComponent } from 'src/app/top-bar/store-info/store-info.component';
import { CommonMethodService } from 'src/app/Shared/common-method.service';
import { environment } from 'src/environments/environment';
import { ECallScriptSections, EUserFunctions } from 'src/app/Shared/enum';
import { PricingCategoryService } from 'src/app/services/pricing-category.service';
import { AmenitiesService } from 'src/app/services/operations/amenities.service';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';
import { MarketingService } from 'src/app/services/marketing.service';
import { ICompetitorMarketRateDetail, IFacilityMapLocation } from 'src/app/Shared/interface2';
import { ICompetitorMapPinInput } from 'src/app/Shared/competitor-market-map/competitor-market-map.component';


@Component({
    selector: 'app-unitSelection',
    templateUrl: 'fac-Ops-unitSelection.component.html',
    styleUrls: ['fac-Ops-unitSelection.component.scss'],
    standalone: false
})

export class FacOpsUnitSelectionComponent implements OnInit {
    unitSelectionFields = [];
    unitDegrees: { [key: number]: string } = {};
    @Output() closeAddUnitEmit = new EventEmitter();
    section = ECallScriptSections.Prospect;
    isUnitSelectionOpen = false;
    expandedUnits: { [key: number]: boolean } = {};
    defaultDate;
    isIPBasedLogin = false;
    GeolocationBasedLogin = false;
    @Output() emitSelectedUnits = new EventEmitter();
    @Input() unitSelectionType;
    @Input() selectedLocation;
    @Input() routerdashboard;
    @Input() unittypecode;
    storeList = [];
    unitTypeList: any = [];
    selectedRadius = '';
    selectedDate = '';
    selectedZip = '';
    selectedSize = '0';
    selectedStatus = 'Vacant';
    selectedCapacity = '0';
    selectedCategory = null;
    selectedAttribute = null;
    selectedPricingCategory = '0';
    selectedAmenity = '0';
    amenitiyListName = '';
    amenitiesList: any;
    isSearchedByUnitNum = false;
    selectedUnits = [];
    searchUnitNum = '';
    filterStatusList = [];
    filterAttributeList = [];
    filterCategoryList = [];
    isUnitTypePresent = false;
    unitTypeSizeList = [];
    unitTypeStatusList = [];
    unitTypeCapacityList = [];
    unitTypeCategoryList = [];
    unitTypeAttributesList = [];
    miscellaneousSettings: any;
    locationList = [];
    MinDate;
    MaxDate;
    isUnitTypeOpened = false;
    masterList = [];
    showLocationInfo = true;
    isReservationModule = false;
    isEditReservation = false;
    isEditInquiry = false;
    CountryId: number;
    toasterConfig = {
        closeButton: true,
        timeOut: 4500,
        easing: 'ease-out',
        progressBar: true,
        positionClass: 'toast-top-right',
        tapToDismiss: true,
        showEasing: 'swing',
        hideEasing: 'linear',
        showMethod: 'fadeIn',
        hideMethod: 'slideUp'
    };
    loaderIcon: Promise<boolean>;
    // maps the appropriate column to fields property
    public fields: Object = { text: 'Name', value: 'Id' };
    // set the height of the popup element
    public height = '250px';
    // set the placeholder to DropDownList input element
    public watermark = 'Categories';
    public watermark1 = 'Attributes';
    lastAccessedFacility: any;
    isDateRequired: boolean = false;
    @ViewChild(StoreInfoComponent, { static: false }) StoreInfoComponent: StoreInfoComponent;
    private multipleCountryForNearestLocation = environment.multipleCountryForNearestLocation;
  private defaultCountryId = environment.defaultCountryId;
    @ViewChild('AddUnitPopup', { static: false }) addUnitPopup!: ModalDirective;
    modalConfig = {
        backdrop: true,
        ignoreBackdropClick: false
    };
    // Drop Down changes
    // maps the appropriate column to fields property
    public storefields: Object = { text: 'Name', value: 'Id' };
    // set the height of the popup element
    public storeheight: string = '220px';
    // set the placeholder to DropDownList input element
    public storewatermark: string = 'Select';
    // set the placeholder to filter search box input element
    public filterPlaceholder: string = 'Search';
    // filtering event handler to filter a Country
    public onFiltering: EmitType<FilteringEventArgs> = (e: FilteringEventArgs) => {
        let query: Query = new Query();
        //frame the query based on search string with filter type.
        query = (e.text !== '') ? query.where('Name', 'contains', e.text, true) : query;
        //pass the filter data source, filter query to updateData method.
        e.updateData(this.storeList, query);
    }
    pricingCategoryList: any;
    degree = '180deg';
    isCollapsed: boolean = false;
    expandedMainItems: { [key: number]: boolean } = {};
    mainDegrees: { [key: number]: string } = {};
    // FR-15 (StorTrack, corrected target — see Story 5.1 handover): Competitor's Avg column state.
    facilityMapLocation: IFacilityMapLocation;
    selectedCompetitorRates: ICompetitorMarketRateDetail[] = [];
    selectedCompetitorUnitTypeName: string;
    selectedFacilityName: string;
    sqFt: number | undefined;
    newRent: number;
    marketAvg: number;
    marketAvgPercentage: number;
    marketDifferenceText: string;
    minMarketRate: number;
    maxMarketRate: number;
    selectedCompetitorMapPins: ICompetitorMapPinInput[] = [];
    competitorRateModalRef: BsModalRef;
    competitorMapModalRef: BsModalRef;
    constructor(private facOpsDataService: FacOpsDataService,
        private prospectsService: ProspectService,
        private generalService: GeneralService,
        private attributeService: UnitsAttributesService,
        private categoriesService: CategoryService,
        private toastr: ToastrService,
        private userSessionService: UserSessionService,
        private storeService: StoreService,
        private pricingCategoryService: PricingCategoryService,
        // private amenitiesService: AmenitiesService,
        private commonMethod: CommonMethodService,
        private modalWrapper: ModalWrapperService,
        private marketingService: MarketingService,
        private modalService: BsModalService) { }

  ngOnInit() {
        this.getStoreList();
        this.getPricingCategory();
        this.isIPBasedLogin = this.userSessionService.userSessionData.UserGroup.IPBasedLogin;
        this.GeolocationBasedLogin = this.userSessionService.userSessionData.UserGroup.GeolocationBasedLogin;
        this.lastAccessedFacility = this.userSessionService.userSessionData.LastAccessedStoreId;
        if (this.userSessionService.isCallcenterAgent) {
            let item = localStorage.getItem('storagefacility');
            if (+item > 0) {
                this.lastAccessedFacility = +item;
                this.getDayEndCompletedDate(this.lastAccessedFacility)
                this.selectedLocation = this.lastAccessedFacility;
            }
        }

        if (!this.lastAccessedFacility) {
            this.lastAccessedFacility = 0;
        }
        if (this.unitSelectionType === 'all') {
            this.selectedLocation = this.lastAccessedFacility;
        }
        if (this.unitSelectionType === 'prospect') {
            this.getDayEndCompletedDate(this.lastAccessedFacility)
        } else if (this.unitSelectionType === 'reservation') {
            this.isReservationModule = true;
        } else if (this.unitSelectionType === 'transfer') {
            this.getFilterLists();
            this.showLocationInfo = false;
            this.getDayEndCompletedDate(this.lastAccessedFacility)
            this.selectedStatus = 'Vacant';
        }

        this.getStoreList();
        if (this.userSessionService.isCallcenterAgent) {
            let marketInfo = this.facOpsDataService.marketingInfo;
            if (marketInfo && (marketInfo.AdSourceFacility != '0' && marketInfo.AdSourceFacility)) {
                this.selectedLocation = marketInfo.AdSourceFacility;
                this.getDayEndCompletedDate(this.selectedLocation)
            }
        }

        this.facOpsDataService.emitAdSourceFacility.subscribe((facId) => {
            if (this.selectedLocation == 0) {
                this.selectedLocation = facId;
                this.getDayEndCompletedDate(this.selectedLocation)
                this.addLocation(facId);
            }
        });
        this.facOpsDataService.isScriptDataPresent(this.section, false, false, false);
        this.facOpsDataService.setCurrentType(ECallScriptSections.Prospect, false);
    }
    openModal(){
        this.modalWrapper.openDirective(this.addUnitPopup);
    }
    
    getStoreList() {
        this.loaderIcon = Promise.resolve(true);
        this.storeService.getStores().subscribe((response: IStore[]) => {
            this.storeList = response;
            this.loaderIcon = Promise.resolve(false);
            if (this.unitSelectionType === 'prospect' || this.unitSelectionType === 'reservation') {
                if (this.getProcessingUnit != undefined) {
                    const facId = this.storeList.find(o => o.Name.toLowerCase() === this.getProcessingUnit.FacilityName.toLowerCase()).Id;
                    this.selectedLocation = facId;
                }
                this.addLocation(this.selectedLocation);
            } else if (this.unitSelectionType === 'all') {
                this.selectedLocation = this.lastAccessedFacility;
                this.addLocation(this.selectedLocation);
            }
            if (this.routerdashboard === true) {
                this.getFilterLists();
            }
        }, err => {
            this.loaderIcon = Promise.resolve(false);
        });
    }
    getFacilityMiscellaneousSettings(fId) {
        this.prospectsService.getFacilityMiscellaneousSettings(fId).subscribe((res) => {
            this.miscellaneousSettings = res;
        });
    }

  getFilterLists() {
        const obj = {
            Id: 0,
            Code: '',
            Name: 'SELECT',
            ImageId: 0,
            SmallImageURL: '',
            MediumImageURL: '',
            LargeImageURL: '',
        };
        if (this.facOpsDataService.lovStatusList && !this.facOpsDataService.lovStatusList.length) {
            if (this.userSessionService.lovList && this.userSessionService.lovList.length) {
                this.filterStatusList = this.userSessionService.getLovListForType(19);
                this.facOpsDataService.lovStatusList = this.userSessionService.getLovListForType(19);
                this.filterList();
            } else {
                this.generalService.getAllListOfValues().subscribe((response: any) => {
                    if (response.length) {
                        this.userSessionService.lovList = response;
                        this.filterStatusList = this.userSessionService.getLovListForType(19);
                        this.facOpsDataService.lovStatusList = this.userSessionService.getLovListForType(19);
                        this.filterList();
                    }
                });
            }
        } else {
            this.filterStatusList = this.facOpsDataService.lovStatusList;
            this.filterList();
        }

        if (this.facOpsDataService.categoryList && !this.facOpsDataService.categoryList.length) {
            this.categoriesService.GetCategoryForOp().subscribe((response: ICategory[]) => {
                this.filterCategoryList = response;
                this.facOpsDataService.categoryList = response;
            });
        } else {
            this.filterCategoryList = this.facOpsDataService.categoryList;
        }

        if (this.facOpsDataService.attributeList && !this.facOpsDataService.attributeList.length) {
            this.attributeService.getAttributesListForOp().subscribe((response: IUnitsAttribute[]) => {
                this.filterAttributeList = response;
                this.facOpsDataService.attributeList = response;
                if (this.routerdashboard === true) {
                    this.isSearchedByUnitNum = false;
                    this.getUnitTypes(this.selectedLocation, 2)
                    var element = (document.getElementById("removecollapse") as HTMLElement);
                    element.classList.remove("collapsed");
                }
            });
        } else {
            this.filterAttributeList = this.facOpsDataService.attributeList;
            if (this.facOpsDataService.amenitiesList?.length) {
                this.amenitiesList = [...this.facOpsDataService.amenitiesList];
            }
            if (this.routerdashboard === true) {
                this.isSearchedByUnitNum = false;
                this.getUnitTypes(this.selectedLocation, 2)
                var element = (document.getElementById("removecollapse") as HTMLElement);
                element.classList.remove("collapsed");
            }
        }
    }

    getLocationList() {
        this.loaderIcon = Promise.resolve(true);
        if (this.multipleCountryForNearestLocation == true) {
            this.CountryId = this.facOpsDataService.selectedContactCountryId;
        } else if (this.multipleCountryForNearestLocation == false) {
            this.CountryId = this.defaultCountryId;
        }
        this.prospectsService.getNearestLocation(this.selectedZip, this.selectedRadius, this.CountryId).subscribe((response: INearestLocation[]) => {
            this.locationList = response;
            if (response == null) {
                this.locationList = [];
                const tempLocObj = {
                    Id: 0,
                    Code: '',
                    Name: 'No records found!',
                    Address: '',
                    City: '',
                    State: '',
                    District: '',
                    Zip: '',
                    Distance: '',
                    UnitTypeList: []
                };
                this.locationList.push(tempLocObj);
            } else if (this.locationList.length === 0) {
                this.locationList = [];
                const tempLocObj = {
                    Id: 0,
                    Code: '',
                    Name: 'No records found!',
                    Address: '',
                    City: '',
                    State: '',
                    District: '',
                    Zip: '',
                    Distance: '',
                    UnitTypeList: []
                };
                this.locationList.push(tempLocObj);
            }
            this.masterList = JSON.parse(JSON.stringify(this.locationList));
            this.loaderIcon = Promise.resolve(false);
            let locArray = this.getUnitSelectionList;
            if (locArray && locArray.length) {
                locArray.map((item) => { if (item.unitTypesCalled) { item.unitTypesCalled = false; } });
            }
            this.expandedMainItems = {};
            this.mainDegrees = {};
            this.locationList.forEach(loc => {
                this.mainDegrees[loc.Id] = '180deg';
            });

            setTimeout(() => {
                this.locationList.forEach(loc => {
                    const element = document.getElementById('MAINID' + loc.Id);
                    if (element) {
                        element.style.transform = 'rotate(180deg)';
                    }
                });
            }, 0);
        }, (err) => {
            this.loaderIcon = Promise.resolve(false);
            this.toastr.error(err.status + ' : ' + err.statusText, 'Failed to get nearest location !', this.toasterConfig);
        }
        );
    }

    getFacilityReserrvationSettings(facId) {
        this.prospectsService.getFacilityReservationSettings(facId).subscribe((res: IFacilityReservationSettings) => {
            const tempResvSettings = res;
            tempResvSettings['FacilityId'] = facId;
            const reservationSettingArray = this.getFacilityReservationSettingservice;
            reservationSettingArray.push(tempResvSettings);
            this.setFacilityReservationSetting = reservationSettingArray;
            this.locationList.find(o => o.Id === facId).UnitTypeList.map((ele) => {
                ele['Warning'] = false;
                if ((ele.AvailableUnits < tempResvSettings.VacantCountLimit) && ele.UnitTypeId > 0) {
                    ele['Warning'] = true;
                }
            });
        });
    }

    getUnitTypes(facId, type) {
        this.getFacilityMiscellaneousSettings(facId);
        let statObj = this.filterStatusList.find(o => o.Name.toLowerCase() == this.selectedStatus.toLowerCase());
        let statusId = 0;
      if (statObj)
        statusId = statObj.Id;
        const obj = {
            FacilityId: facId,
            UnittypeId: 0,
            UnitTypeSize: '',
            StatusId: statusId,
            DateNeeded: '',
            UnitCapacity: '',
            UnitNumber: '',
            CategoryId: 0,
            AttributeId: 0,
            FilterChanged: false,
            LastAppliedFilter: '',
            CallCenterbit: this.userSessionService.isCallcenterAgent,
            channelprice: false,
            ChannelId: 0,
            Source: this.userSessionService.isCallcenterAgent ? 'CALLCENTER' : 'INSTORE'
        };
        let locArray = [];
        locArray = this.getUnitSelectionList;
        if (facId) {
            facId = parseInt(facId, 10);
        }
        let objLoc = locArray.find(o => o.Id === facId);
        if (this.locationList.length > 0 && facId != 0 && (this.locationList.find(o => o.Id === facId).UnitTypeList === undefined ||
            this.locationList.find(o => o.Id === facId).UnitTypeList.length === 0 || type === 2)
            && (!objLoc || objLoc.length == 0 || type === 2) || (objLoc && !objLoc.unitTypesCalled)
        ) {
            this.loaderIcon = Promise.resolve(true);
            this.prospectsService.getUnitTypeList(obj).subscribe((response: IProspectUnitTypeModel) => {
                this.unitTypeList = response.ProspectUnitType;
                this.amenitiesList = [];

                response.ProspectUnitType.forEach(unitType => {
                    if (unitType.ListofAmenitiesBundle?.length) {
                        unitType.ListofAmenitiesBundle.forEach(amenityName => {
                            if (!this.amenitiesList.includes(amenityName)) {
                                this.amenitiesList.push(amenityName);
                            }
                        });
                    }
                });
                this.amenitiesList.sort();
                this.facOpsDataService.amenitiesList = [...this.amenitiesList];

                this.locationList.find(o => o.Id === facId).UnitTypeList = response.ProspectUnitType;
                this.loadCompetitorMarketRatesForUnitTypes(facId, response.ProspectUnitType);
                this.loaderIcon = Promise.resolve(false);
                this.locationList.find(o => o.Id === facId).UnitTypeList.map((ele) => {
                    ele.display = true;
                    if (ele.FacilityReservationSettings) {
                        if (ele.AvailableUnits < ele.FacilityReservationSettings.VacantCountLimit) {
                            ele['Warning'] = true;
                        } else {
                            ele['Warning'] = false;
                        }
                        const tempResvSettings = ele.FacilityReservationSettings;
                        tempResvSettings['FacilityId'] = facId;
                        const reservationSettingArray = this.getFacilityReservationSettingservice;
                        if (reservationSettingArray.findIndex(o => o.FacilityId === facId) === -1) {
                            reservationSettingArray.push(tempResvSettings);
                            this.setFacilityReservationSetting = reservationSettingArray;
                        }
                    }
                    ele.ListOfUnitSize.map((Obj) => {
                        if (Obj) {
                            if (this.unitTypeSizeList.findIndex(o => o.toLowerCase() === Obj.toLowerCase()) === -1) {
                                this.unitTypeSizeList.push(Obj);
                            }
                        }
                    });
                    ele.ListofCapacity.map((Obj) => {
                        if (Obj) {
                            if (this.unitTypeCapacityList.findIndex(
                                o => o.toString().toLowerCase() === Obj.toString().toLowerCase()) === -1) {
                                this.unitTypeCapacityList.push(Obj);
                            }
                        }
                    });
                });

                if (this.routerdashboard === true) {
                    var element = (document.getElementById("ID" + this.selectedLocation) as HTMLElement);
                    element.classList.remove('collapse');
                }
                this.filterList();
                this.masterList = JSON.parse(JSON.stringify(this.locationList));
                let val;
                if (this.routerdashboard === true) {
                    val = this.unitTypeList.find(o => o.UnitTypeCode == this.unittypecode).UnitTypeId;
                    this.getUnitList(val, this.selectedLocation);
                }
                this.locationList.map((item) => {
                    if (item.Id == facId) {
                        item['unitTypesCalled'] = true;
                    }
                })
                this.setLocationUnitSelectionList = JSON.parse(JSON.stringify(this.locationList));
            }, (err) => {
                this.loaderIcon = Promise.resolve(false);
                this.toastr.error(err.status + ' : ' + err.statusText, 'Failed to get Unit types !', this.toasterConfig)
            });
        } else {
            if (this.facOpsDataService.amenitiesList?.length) {
                this.amenitiesList = [...this.facOpsDataService.amenitiesList];
            }
            let tempArray = this.getUnitSelectionList.filter((ele) => {
                if (this.locationList && this.locationList.find(o => o.Id == ele.Id && o.UnitTypeList.length)) {
                } else {
                    return ele;
                }
            });
            if ((document.getElementById('removecollapse') != null && !(document.getElementById('removecollapse').getAttribute('aria-expanded'))) || tempArray.length) {
                this.locationList = this.getUnitSelectionList;
                this.masterList = JSON.parse(JSON.stringify(this.getUnitSelectionList));
            }
          if (this.locationList.length) {
            this.loadCompetitorMarketRatesForUnitTypes(facId,this.locationList.find(o => o.Id === facId).UnitTypeList);
                this.locationList.find(o => o.Id === facId).UnitTypeList.map((ele) => {
                    ele.ListOfUnitSize.map((Obj) => {
                        if (Obj) {
                            if (this.unitTypeSizeList.findIndex(o => o.toLowerCase() === Obj.toLowerCase()) === -1) {
                                this.unitTypeSizeList.push(Obj);
                            }
                        }
                        ele.ListofCapacity.map((Obj) => {
                            if (Obj) {
                                if (this.unitTypeCapacityList.findIndex(
                                    o => o.toString().toLowerCase() === Obj.toString().toLowerCase()) === -1) {
                                    this.unitTypeCapacityList.push(Obj);
                                }
                            }
                        });
                    });
                });
            }
        }
        // this.filterList();
        this.isUnitTypeOpened = true;
        this.checkSelectedUnits();
    }

    getUnitList(unitTypeId, facId) {
        const obj = {
            FacilityId: facId,
            UnittypeId: unitTypeId,
            UnitTypeSize: '',
            StatusId: 0,
            DateNeeded: '',
            UnitCapacity: '',
            UnitNumber: '',
            CategoryId: 0,
            AttributeId: 0,
            FilterChanged: false,
            LastAppliedFilter: '',
            CallCenterbit: this.userSessionService.isCallcenterAgent,
            channelprice: false,
            ChannelId: 0,
            Source: this.userSessionService.isCallcenterAgent ? 'CALLCENTER' : 'INSTORE'
        };
        if (this.locationList.find(o => o.Id === facId).UnitTypeList.find(
            obj => obj.UnitTypeId === unitTypeId).UnitList === undefined) {
            this.loaderIcon = Promise.resolve(true);
            this.prospectsService.getUnitList(obj).subscribe((response: IProspectUnitList[]) => {
                if (response.length)
                    response.map((ele) => { ele['selected'] = false; ele['display'] = true; 
                if (ele.UnitLevelAmenitiesModel) {
                    const amenityModel = ele.UnitLevelAmenitiesModel;
                    amenityModel['AmenityNames'] = this.getAmenityName(amenityModel);
                }
            });
                this.locationList.find(o => o.Id === facId).UnitTypeList.find(
                    obj => obj.UnitTypeId === unitTypeId).UnitList = response;
                this.loaderIcon = Promise.resolve(false);
                this.filterList();
                let selectedUnitTypeObject = this.locationList.find(o => o.Id === facId).UnitTypeList.find(
                    obj => obj.UnitTypeId === unitTypeId);
                selectedUnitTypeObject['SortType'] = 'dsc';
                selectedUnitTypeObject['SortCol'] = null;
                this.sortTable('Rent', unitTypeId, facId, 'Default');
                this.masterList = JSON.parse(JSON.stringify(this.locationList));
                if (this.routerdashboard == true) {
                    var element = (document.getElementById("IDUnitType" + unitTypeId) as HTMLElement);
                    element.classList.remove("collapse");
                    element.scrollIntoView(true);
                }
                this.setLocationUnitSelectionList = JSON.parse(JSON.stringify(this.locationList));
            }, (err) => {
                this.loaderIcon = Promise.resolve(false);
                this.toastr.error(err.status + ' : ' + err.statusText, 'Failed to get Unit List !', this.toasterConfig)
            });
        } else {
            let selectedUnitTypeObject = this.locationList.find(o => o.Id === facId).UnitTypeList.find(
                obj => obj.UnitTypeId === unitTypeId);
            selectedUnitTypeObject['SortType'] = 'dsc';
            selectedUnitTypeObject['SortCol'] = null;
            this.sortTable('Rent', unitTypeId, facId, 'Default');
        }
    }

    collapseAllUnitTypes(): void {
        this.expandedUnits = {};
        this.unitDegrees = {};

        const unitElements = document.getElementsByClassName('rgt_arr_Unit');
        for (let i = 0; i < unitElements.length; i++) {
            (unitElements[i] as HTMLElement).style.transform = `rotate(${this.degree})`;
        }
    }

    filterList(isFilterChange: boolean = false): void {
        if (isFilterChange) {
            this.collapseAllUnitTypes();
        }
        this.locationList.map((ele) => {
            if (ele.UnitTypeList !== undefined) {
                ele.UnitTypeList.map((element) => {

                    if (this.selectedSize !== '0') {
                        let unitSizeIndex = element.ListOfUnitSize.findIndex(
                            o => o.toLowerCase() == this.selectedSize.toLowerCase());
                        if (unitSizeIndex && unitSizeIndex == -1) {
                            element.display = false;
                            return;
                        } else {
                            element.display = true;
                        }
                    }

                    if (this.selectedStatus !== '0' && this.filterStatusList.length != 0) {
                        let statusId = this.filterStatusList.find(
                            o => o.Name.toLowerCase() == this.selectedStatus.toLowerCase()).Id;
                        let statusIndex = element.ListofStatus.findIndex(o => o === statusId);
                        if (statusIndex && statusIndex == -1) {
                            element.display = false;
                            return;
                        } else {
                            element.display = true;
                        }
                    }

                    if (this.selectedCapacity !== '0') {
                        let unitCapacityIndex = element.ListofCapacity.findIndex(
                            o => o.toString().toLowerCase() === this.selectedCapacity.toString().toLowerCase());
                        if (unitCapacityIndex && unitCapacityIndex == -1) {
                            element.display = false;
                            return;
                        } else {
                            element.display = true;
                        }
                    }

                    if (this.selectedAttribute !== null) {
                        if (element.ListofAttributes) {
                            let unitAttributeIndex = element.ListofAttributes.findIndex(
                                o => o === parseInt(this.selectedAttribute, 10));
                            if (unitAttributeIndex && unitAttributeIndex == -1) {
                                element.display = false;
                                return;
                            } else {
                                element.display = true;
                            }
                        } else {
                            element.display = false;
                            return;
                        }
                    }

                    if (this.selectedPricingCategory !== '0') {
                        let pricingCategoryId = this.pricingCategoryList.find(
                            o => o.PricingCategoryName.toLowerCase() == this.selectedPricingCategory.toLowerCase()
                        ).PricingCategoryId;
                        let pricingCategoryIndex = element.ListofPricingCategory.findIndex(
                            o => o === pricingCategoryId);
                        if (pricingCategoryIndex && pricingCategoryIndex == -1) {
                            element.display = false;
                            return;
                        } else {
                            element.display = true;
                        }
                    }

                    if (this.selectedAmenity !== '0') {
                        if (!element.ListofAmenitiesBundle?.length ||
                            !element.ListofAmenitiesBundle.includes(this.selectedAmenity)) {
                            element.display = false;
                            return;
                        } else {
                            element.display = true;
                        }
                    }

                    let size, status, capacity, attr, pricingcatgry, amenity;
                    if (element.UnitList !== undefined) {
                        element.UnitList.map((ele) => {
                            size = this.selectedSize !== '0'
                                ? ele.UnitSize.toLowerCase() === this.selectedSize.toLowerCase()
                                : true;

                            status = this.selectedStatus !== '0'
                                ? ele.Status.toLowerCase() === this.selectedStatus.toLowerCase()
                                : true;

                            capacity = this.selectedCapacity !== '0'
                                ? (ele.Capacity
                                    ? ele.Capacity.toString().toLowerCase() === this.selectedCapacity.toString().toLowerCase()
                                    : false)
                                : true;

                            attr = this.selectedAttribute !== null
                                ? ele.UnitLevelAttributeModel.findIndex(
                                    o => o.AttributeId === parseInt(this.selectedAttribute, 10)) !== -1
                                : true;

                            pricingcatgry = this.selectedPricingCategory !== '0'
                                ? (ele.PricingCategoryName
                                    ? ele.PricingCategoryName.toLowerCase() === this.selectedPricingCategory.toLowerCase()
                                    : false)
                                : true;

                            amenity = this.selectedAmenity !== '0'
                                ? ele.UnitLevelAmenitiesModel?.AmenityNames?.includes(this.selectedAmenity) ?? false
                                : true;

                            ele.display = size && status && attr && capacity && pricingcatgry && amenity;
                        });
                    }

                    const anyFilterActive = this.selectedStatus !== '0'
                        || this.selectedSize !== '0'
                        || this.selectedCapacity !== '0'
                        || this.selectedAttribute !== null
                        || this.selectedPricingCategory !== '0'
                        || this.selectedAmenity !== '0';

                    if (anyFilterActive && element.UnitList !== undefined && element.UnitList.length > 0) {
                        const hasVisibleUnit = element.UnitList.some(u => u.display === true);
                        if (!hasVisibleUnit) {
                            element.display = false;
                            return;
                        }
                    }

                    if (this.selectedCategory !== null) {
                        if (element.ListofCategory.findIndex(
                            o => o === parseInt(this.selectedCategory, 10)) === -1) {
                            element.display = false;
                        } else {
                            element.display = true;
                        }
                    } else if (!element.Capacity) {
                        if (this.selectedCapacity !== '0') {
                            element.display = false;
                        } else {
                            element.display = true;
                        }
                    } else {
                        if (element.UnitList !== undefined) {
                            if (this.checkUnitList(element.UnitList)) {
                                element.display = false;
                            } else {
                                element.display = true;
                            }
                        } else {
                            element.display = true;
                        }
                    }
                });
            }
        });

        this.checkSelectedUnits();
        this.masterList = JSON.parse(JSON.stringify(this.locationList));
    }

    clearAllFilter() {
        this.selectedSize = '0';
        this.selectedStatus = '0';
        this.selectedCapacity = '0';
        this.selectedPricingCategory = '0';
        this.selectedAmenity = '0';
        this.selectedCategory = null;
        this.selectedAttribute = null;
        this.expandedUnits = {};
        this.unitDegrees = {};
        this.getUnitTypes(this.selectedLocation || this.lastAccessedFacility, 2)
    }

    checkSelectedUnits() {
        this.locationList.map((ele) => {
            if (ele.UnitTypeList !== undefined) {
                ele.UnitTypeList.map((element) => {
                    if (element.UnitList !== undefined) {
                        element.UnitList.map((unitEle) => {
                            if (this.selectedUnits.findIndex(o => o.UnitId === unitEle.UnitId) !== -1) {
                                unitEle.selected = true;
                            } else {
                                unitEle.selected = false;
                            }
                        });
                    }
                });
            }
        });
    }

    searchByUnitNum() {
        this.loaderIcon = Promise.resolve(true);
        this.isSearchedByUnitNum = true;
        const fIdList = this.masterList.map((ele) => ele.Id);
        const obj = {
            UnitNumber: this.searchUnitNum,
            DateNeeded: this.selectedDate,
            FacilityId: fIdList,
            ChannelId: 0,
            Source: this.userSessionService.isCallcenterAgent ? 'CALLCENTER' : 'INSTORE'
        };
        this.prospectsService.getUnitSearchDetails(obj).subscribe((response: IProspectUnitSearchList[]) => {
            this.locationList = [];
            const tempArray = response;
            tempArray.map((ele) => {
                const unitType = [];
                const reservationSetting = this.getFacilityReservationSettingservice?.find(s => s.FacilityId === ele.FacilityId);
                if (ele.UnitTypeForUnitNumbers.ListofUnits.Status == this.selectedStatus || this.selectedStatus == '0') {
                    const tempObj = {
                        UnitTypeId: ele.UnitTypeForUnitNumbers.UnitTypeId,
                        UnitTypeSize: ele.UnitTypeForUnitNumbers.UnitTypeSize,
                        CategorySmallImageURL: ele.UnitTypeForUnitNumbers.CategorySmallImageURL,
                        CategoryMediumImageURL: ele.UnitTypeForUnitNumbers.CategoryMediumImageURL,
                        CategoryLargeImageURL: ele.UnitTypeForUnitNumbers.CategoryLargeImageURL,
                        Capacity: ele.UnitTypeForUnitNumbers.Capacity,
                        AvailableUnits: ele.UnitTypeForUnitNumbers.AvailableUnits,
                        ListOfUnitSize: ele.UnitTypeForUnitNumbers.ListOfUnitSize,
                        ListofStatus: ele.UnitTypeForUnitNumbers.ListofStatus,
                        ListofCapacity: ele.UnitTypeForUnitNumbers.ListofCapacity,
                        ListofCategory: ele.UnitTypeForUnitNumbers.ListofCategory,
                        ListofAttributes: ele.UnitTypeForUnitNumbers.ListofAttributes,
                        UnitList: [ele.UnitTypeForUnitNumbers.ListofUnits],
                        Warning: ele.UnitTypeForUnitNumbers.AvailableUnits < reservationSetting.VacantCountLimit
                    };
                    unitType.push(tempObj);
                }
                const tempLocObj = {
                    Id: ele.FacilityId,
                    Code: '',
                    Name: this.storeList.find(o => o.Id === ele.FacilityId).Name,
                    Address: '',
                    City: '',
                    State: '',
                    District: '',
                    Zip: '',
                    Distance: '',
                    UnitTypeList: unitType
                };
                this.locationList.push(tempLocObj);
                this.locationList.find(o => o.Id === ele.FacilityId).UnitTypeList.map((ele) => { ele.display = true;
                    if (ele.UnitList && ele.UnitList.length > 0) {
                        ele.UnitList.forEach((unit) => {
                            if (unit.PricingCategoryId) {
                                const pricingCategory = this.pricingCategoryList.find(x => x.PricingCategoryId === unit.PricingCategoryId);
                                if (pricingCategory) {
                                    unit['PricingCategoryName'] = pricingCategory.PricingCategoryName;
                                }
                            }
                            if (unit.UnitLevelAmenitiesModel) {
                                const amenityModel = unit.UnitLevelAmenitiesModel;
                                amenityModel['AmenityNames'] = this.getAmenityName(amenityModel); 
                            }
                        });
                    }
                });
            });
            this.locationList.forEach((loc) => {
                this.loadCompetitorMarketRatesForUnitTypes(loc.Id, loc.UnitTypeList);
            });
            if (tempArray.length === 0) {
                const tempLocObj = {
                    Id: 0,
                    Code: '',
                    Name: 'No records found!',
                    Address: '',
                    City: '',
                    State: '',
                    District: '',
                    Zip: '',
                    Distance: '',
                    UnitTypeList: []
                };
                this.locationList.push(tempLocObj);
            }
            this.loaderIcon = Promise.resolve(false);
        }, (err) => {
            this.loaderIcon = Promise.resolve(false);
            this.toastr.error(err.status + ' : ' + err.statusText, 'Failed to get Units !', this.toasterConfig)
        });
    }

  resetSearch() {
        this.isSearchedByUnitNum = false;
        this.locationList = JSON.parse(JSON.stringify(this.masterList));
        this.searchUnitNum = '';
        this.filterList();
        // Patch (2026-09-15 review): masterList was cloned before the async competitor-rate
        // response could attach CompetitorMarketRate, so restoring from it needs a fresh reload.
        this.locationList.forEach((loc) => {
            this.loadCompetitorMarketRatesForUnitTypes(loc.Id, loc.UnitTypeList);
        });
    }

    addUnitToList(uId, fId, unitTypeId, event) {
        const datepipe: DatePipe = new DatePipe('en');
        const date = new Date(this.selectedDate);
        const dateStr = datepipe.transform(date, 'MM/dd/yyyy');
         const unit = this.locationList.find(o => o.Id === fId)
        .UnitTypeList.find(o => o.UnitTypeId === unitTypeId)
        .UnitList.find(o => o.UnitId === uId);
        const amenities = unit?.UnitLevelAmenitiesModel;
        const obj = {
            UnitId: uId,
            FacilityId: fId,
            DateNeeded: dateStr,
            PrepayMonths: amenities?.PrepayMonths ?? 0,
            UnitNumber: this.locationList.find(o => o.Id === fId).UnitTypeList.find(
                o => o.UnitTypeId === unitTypeId).UnitList.find(o => o.UnitId === uId).UnitNumber,
            Warning: this.locationList.find(o => o.Id === fId).UnitTypeList.find(
                o => o.UnitTypeId === unitTypeId).Warning,
            Status: this.locationList.find(o => o.Id === fId).UnitTypeList.find(
                o => o.UnitTypeId === unitTypeId).UnitList.find(o => o.UnitId === uId).Status.toLowerCase(),
            TypeCode: this.locationList.find(o => o.Id === fId).UnitTypeList.find(
                o => o.UnitTypeId === unitTypeId).UnitList.find(o => o.UnitId === uId).UnitTypeCode
        };
        if (this.unitSelectionType !== 'all') {
            this.selectedUnits = [];
        }
        if (event.target.checked) {

            this.selectedUnits.push(obj);
        } else {
            const pos = this.selectedUnits.findIndex(o => o.UnitId === uId);
            if (pos !== -1) {
                this.selectedUnits.splice(pos, 1);
            }
        }
        this.checkSelectedUnits();
    }

    removeSelectedUnit(uId) {
        const pos = this.selectedUnits.findIndex(o => o.UnitId === uId);
        if (pos !== -1) {
            this.selectedUnits.splice(pos, 1);
            this.checkSelectedUnits();
        }
    }

  addLocation(id) {
        if (id) {
            const tempLocObj = {
                Id: parseInt(id, 10),
                Code: '',
                Name: this.storeList.find(o => o.Id === parseInt(id, 10)).Name,
                Address: this.storeList.find(o => o.Id === parseInt(id, 10)).Address,
                City: '',
                State: '',
                District: '',
                Zip: '',
                Distance: '',
                UnitTypeList: []
            };
            this.locationList = [];
            this.locationList.push(tempLocObj);
            if (this.isReservationModule) {
                this.limitationForReservationCheck(this.selectedDate);
            }
            this.facOpsDataService.emitUnitStore.emit(id);
            this.getDayEndCompletedDate(id);
            this.loadFacilityMapLocation(id);
        }
        this.getUnitTypes(id, 1)
            this.expandedMainItems[id]=true;
    }

    passSelectedUnits() {
        const datepipe: DatePipe = new DatePipe('en');
        const date = new Date(this.selectedDate);
        const dateStr = datepipe.transform(date, 'MM/dd/yyyy');
        const obj = {
            selDate: dateStr,
            selRadius: this.selectedRadius,
            selZip: this.selectedZip,
            selLocation: this.selectedLocation,
            selUnits: this.selectedUnits,
            Transfer: false
        };
        this.setLocationUnitSelectionList = this.masterList;
        this.setSelectedUnits = this.selectedUnits;
        this.emitSelectedUnits.emit(obj);
        this.addUnitPopup.hide();
    }

    checkItemExists(arr) {
        if (arr.length !== 0) {
            const count = arr.filter((ele) => ele.display === true).length;
            if (count === 0) {
                if (!this.isUnitTypePresent) {
                    this.isUnitTypePresent = true;
                } else {
                    this.isUnitTypePresent = false;
                }
                return true;
            } else {
                this.isUnitTypePresent = false;
                return false;
            }
        }
    }

    checkUnitList(arr) {
        if (arr !== undefined && arr.length !== 0) {
            const count = arr.filter((ele) => ele.display === true).length;
            if (count === 0) {
                return true;
            } else {
                return false;
            }
        }
    }

    checkUnitTypeList(arr) {
        if (arr && arr.length) {
            let count = arr.filter((ele) => ele.display === true).length;
            if (count === 0) {
                return true;
            }
            return false;
        }
    }

  clearItems(type) {
        this.locationList = [];
        this.masterList = [];
        if (!this.userSessionService.isCallcenterAgent) {
            this.selectedLocation = 0;
        }
        this.selectedRadius = '';
        this.selectedZip = '';
        this.isUnitTypeOpened = false;
        this.selectedUnits = [];
        this.selectedCategory = null;
        this.selectedAttribute = null;
        if (type !== 'onAdd') {
            this.closeAddUnitEmit.emit(true);
        }
        this.resetSearch();
        if (this.unitSelectionType === 'all') {
            if (!this.userSessionService.isCallcenterAgent) {
                this.selectedLocation = this.lastAccessedFacility;
            }
            this.addLocation(this.selectedLocation);
        }
    }
    closeModal() {
        this.clearItems('');
        // Patch (2026-09-15 review): these BsModalService modals render into <body>, independent
        // of addUnitPopup, and are orphaned on screen if left open when Add Unit closes.
        this.competitorRateModalRef?.hide();
        this.competitorMapModalRef?.hide();
        this.addUnitPopup.hide()
    }
    changeCategory(data) {
        this.selectedCategory = data;
        this.filterList();
    }

    dateChanged(data) {
        if (!data) {
            this.isDateRequired = true;
        } else {
            this.isDateRequired = false;
            if (this.isReservationModule) {
                this.limitationForReservationCheck(data);
            }
        }
    }

    limitationForReservationCheck(data) {
        if (this.locationList.length > 0 && this.selectedLocation != 0) {
            if (this.locationList.find(o => o.Id === this.selectedLocation) != undefined) {
                if (this.locationList.find(o => o.Id === this.selectedLocation).UnitTypeList.length > 0) {
                    this.locationList.find(o => o.Id === this.selectedLocation).UnitTypeList.map((ele) => {
                        if (ele.FacilityReservationSettings) {
                            if (ele.AvailableUnits < ele.FacilityReservationSettings.VacantCountLimit) {
                                ele['Warning'] = true;
                            } else {
                                ele['Warning'] = false;
                            }
                        }
                    });
                }
            }
        }
    }

    checkUnitDisabled(unitId, unitStatus, unitTypeItems) {
        if (this.isReservationModule && (unitTypeItems.Warning || unitStatus !== 'Vacant')) {
            return true;
        } else if (this.unitSelectionType === 'all') {
            let unitList = this.getUnitLists;
            if (unitList && unitList.length) {
                let index = unitList.findIndex(o => o.UnitId === unitId && (o.StatusDescription !== 'Expired'
                    && o.StatusDescription !== 'Cancelled' && o.StatusDescription !== 'Closed' &&
                    o.StatusDescription !== 'Reserved' && o.StatusDescription !== 'Rented'));
                if (index !== -1) {
                    return true;
                } else {
                    let processingId = this.facOpsDataService.processingUnitId;
                    let index2 = unitList.findIndex(o => o.UnitId == processingId)
                    if (processingId && processingId == unitId && index2 == -1) {
                        return true;
                    }
                }
            } else if (this.facOpsDataService.allProspectList) {
                let allprospectList = this.facOpsDataService.allProspectList[0];
                if (allprospectList) {
                    let inqUnit = null;
                    let resUnit = null;
                    allprospectList.InquiryInfo.map((item) => {
                        if (item.UnitInfo.UnitId == unitId && (item.UnitInfo.StatusDescription !== 'Cancelled' && item.UnitInfo.StatusDescription !== 'Closed'
                            && item.UnitInfo.StatusDescription !== 'Reserved' && item.UnitInfo.StatusDescription !== 'Rented')) {
                            inqUnit = item;
                        }
                    });
                    allprospectList.ReservationInfo.map((item) => {
                        if (item.UnitInfo.UnitId == unitId && (item.UnitInfo.StatusDescription !== 'Cancelled' && item.UnitInfo.StatusDescription !== 'Expired'
                            && item.UnitInfo.StatusDescription !== 'Reserved' && item.UnitInfo.StatusDescription !== 'Rented')) {
                            resUnit = item;
                        }
                    })
                    if (inqUnit || resUnit) {
                        return true;
                    }
                }

            }
        } else if (this.unitSelectionType == 'transfer' && unitStatus !== 'Vacant') {
            return true;
        } else {
            let processingId = this.facOpsDataService.processingUnitId;
            if (processingId && processingId == unitId) {
                return true;
            }
        }
        return false;
    }

    onDatePickerLoad(args) {
        if (this.isEditReservation || this.isEditInquiry) {
            const todayDate = new Date();
            const reqDate = new Date(this.selectedDate);
            if (args.date.setHours(0, 0, 0, 0) < todayDate.setHours(0, 0, 0, 0) &&
                (args.date.setHours(0, 0, 0, 0) !== reqDate.setHours(0, 0, 0, 0))) {
                args.isDisabled = true;
            }
        }
    }
    set setLocationUnitSelectionList(value) {
        this.facOpsDataService.locationUnitList = value;
    }
    set setSelectedUnits(value) {
        this.facOpsDataService.selectedUnits = value;
    }
    set setFacilityReservationSetting(value) {
        this.facOpsDataService.facilityReservationSettingList = value;
    }
    get getUnitSelectionList() {
        return this.facOpsDataService.locationUnitList;
    }
    get getSelectedUnits() {
        return this.facOpsDataService.selectedUnits;
    }
    get getUnitLists() {
        return this.facOpsDataService.unitList;
    }
    get getProcessingUnit() {
        return this.facOpsDataService.processingUnit;
    }
    get getFacilityReservationSettingservice() {
        return this.facOpsDataService.facilityReservationSettingList;
    }

    onClickStore(FacilityId) {
        this.StoreInfoComponent.storeInfoFacId = FacilityId;
        this.StoreInfoComponent.openModal();
    }

    getDayEndCompletedDate(facilityId) {
        this.generalService.getDayEndCompletedDate(facilityId).subscribe((response) => {
            if (response) {
                let FacilityDate = this.commonMethod.getFormattedDate(response.FacilityDateTime);
                if (response.DayendDate && response.NextDayendDate) {
                    let dayEndDate = this.commonMethod.getFormattedDate(response.DayendDate);
                    if (new Date(FacilityDate) > new Date(dayEndDate)) {
                        this.defaultDate = this.commonMethod.getFormattedDate(response.FacilityDateTime);
                    } else {
                        this.defaultDate = this.commonMethod.getFormattedDate(response.NextDayendDate);
                    }
                } else {
                    this.defaultDate = this.commonMethod.getFormattedDate(response.FacilityDateTime);
                }
                if (!this.isEditReservation) {
                    this.selectedDate = this.defaultDate;
                }
            }
        });
    }

    validateZipInput(eve){
        this.commonMethod.validateZipInput(eve);
      }

    sortTable(key, unitTypeId, facId, type: string = null) {
        let selectedUnitTypeObject = this.locationList.find(o => o.Id === facId).UnitTypeList.find(
            obj => obj.UnitTypeId === unitTypeId);
        let selectedSortUnitsList = selectedUnitTypeObject.UnitList;
        selectedSortUnitsList.sort(function (a, b) {
            let titleA: string = '';
            let titleB: string = '';
            if (a[key] !== null && b[key] !== null) {
                if (typeof a[key] === 'number') {
                    if (selectedUnitTypeObject['SortType'] === 'asc') {
                        return b[key] - a[key];
                    } else {
                        return a[key] - b[key];
                    }
                } else if (typeof a[key] === 'object' && key === 'UnitLevelDiscountModel') {
                    if (a[key] && a[key][0]) {
                        titleA = a[key][0].DiscountName.toString().toLowerCase();
                    }
                    if (b[key] && b[key][0]) {
                        titleB = b[key][0].DiscountName.toString().toLowerCase();
                    }
                } else if (typeof a[key] === 'object' && key === 'UnitLevelAttributeModel') {
                    if (a[key] && a[key][0]) {
                        titleA = a[key][0].AttributeName.toString().toLowerCase();
                    }
                    if (b[key] && b[key][0]) {
                        titleB = b[key][0].AttributeName.toString().toLowerCase();
                    }
                } else {
                    titleA = a[key].toString().toLowerCase();
                    titleB = b[key].toString().toLowerCase();
                }
            }
            if (selectedUnitTypeObject['SortType'] === 'asc') {
                if (titleB < titleA) { return -1; }
                if (titleB > titleA) { return 1; }
                return 0;
            } else {
                if (titleA < titleB) { return -1; }
                if (titleA > titleB) { return 1; }
                return 0;
            }
        });
        if (type != 'Default') {
            if (selectedUnitTypeObject['SortType'] === 'asc') {
                selectedUnitTypeObject['SortType'] = 'dsc';
                selectedUnitTypeObject['SortCol'] = key;
            } else {
                selectedUnitTypeObject['SortType'] = 'asc';
                selectedUnitTypeObject['SortCol'] = key;
            }
        }
    }

    closeAddUnitAutomatic() {
        this.isUnitSelectionOpen = false;
        document.getElementById("addUnit-close").click();
    }

    addSelectedUnitsOnScriptChange() {
        this.isUnitSelectionOpen = false;
        document.getElementById("selectcardview").click();
    }

    getPricingCategory(){
        this.pricingCategoryService.getPricingCategoryListForOp().subscribe((response: IPricingCategory[]) => {
        this.pricingCategoryList =  response;
        })
    }

    // FR-15: own-facility coordinates/name for the shared competitor-market-map's "own facility" pin.
    loadFacilityMapLocation(facilityId) {
        if (this.userSessionService.userFunctionPermissions.find(o => o.FunctionId === EUserFunctions['Market Analysis Competitors'] && o.UserGroupRights?.ViewRight)) {
            this.marketingService.getFacilityMapLocation(facilityId).subscribe({
                next: (location) => {
                    // Patch (2026-09-15 review): drop a stale response from a facility the user has
                    // since navigated away from (rapid facility switching can resolve out of order).
                    if (this.selectedLocation == facilityId) {
                        this.facilityMapLocation = location;
                    }
                },
                error: () => {
                    this.toastr.error('Failed to load facility map location', 'Failure', this.toasterConfig);
                }
            });
        }
    }

    // FR-15: batched (one call per unit-type list load, not per row) competitor market rate lookup.
    // Partial<IProspectUnitInfo> (not the full interface) since the unit-number-search flow builds
  // its own lighter-weight unit-type-like objects that don't carry every IProspectUnitInfo field.
    loadCompetitorMarketRatesForUnitTypes(facilityId: number, unitTypes: Partial<IProspectUnitInfo>[]) {
        const unitTypeIds = (unitTypes || []).filter(ut => ut.UnitTypeId != null).map(ut => ut.UnitTypeId);
        if (!unitTypeIds.length) {
            return;
        }
        if (this.userSessionService.userFunctionPermissions.find(o => o.FunctionId === EUserFunctions['Market Analysis Competitors'] && o.UserGroupRights?.ViewRight)) {
            this.marketingService.getUnitTypeMarketRates(facilityId, unitTypeIds).subscribe({
                next: (rates) => {
                    (rates || []).forEach((rate) => {
                        const unitType = unitTypes.find((ut) => ut.UnitTypeId === rate.UnitTypeId);
                        if (unitType) {
                            unitType.CompetitorMarketRate = rate;
                        }
                    });
                },
                error: () => {
                    this.toastr.error('Failed to load competitor market rates', 'Failure', this.toasterConfig);
                }
            });
        }
    }

    // FR-15 AC #3: List icon opens the shared competitor-rate detail view.
  openCompetitorRateDetail(unitType: Partial<IProspectUnitInfo>, template: TemplateRef<any>) {
        this.selectedCompetitorRates = unitType.CompetitorMarketRate?.CompetitorRates || [];
        this.selectedCompetitorUnitTypeName = unitType.UnitTypeCode;
        this.sqFt = Array.isArray(unitType.Sqft) ? unitType.Sqft[0] : unitType.Sqft;
        this.selectedFacilityName = this.facilityMapLocation?.FacilityName;
        this.newRent = unitType.CompetitorMarketRate?.NewRent ?? 0;
        this.marketAvg = unitType.CompetitorMarketRate?.AverageOccupiedRent ?? 0;
        this.marketAvgPercentage = this.marketAvg !== 0 ? Math.round(Math.abs(((this.marketAvg - this.newRent) / this.marketAvg) * 100)) : 0;
        this.marketDifferenceText = this.newRent === this.marketAvg ? "at" : (this.newRent < this.marketAvg ? "below" : "above");
        const rates = this.selectedCompetitorRates?.filter(x => x.IsAvailable && x.Rate != null).map(x => Number(x.Rate)) ?? [];
        this.minMarketRate = rates.length ? Math.min(...rates) : 0;
        this.maxMarketRate = rates.length ? Math.max(...rates) : 0;
        this.competitorRateModalRef = this.modalService.show(template, { class: 'competitor-rate-modal modal-dialog-centered' });
    }

    // FR-15 AC #4: Map icon opens the shared competitor-market-map component (AD-11).
    openCompetitorMapModal(unitType: Partial<IProspectUnitInfo>, template: TemplateRef<any>) {
        this.selectedCompetitorMapPins = (unitType.CompetitorMarketRate?.CompetitorRates || [])
            .filter((rate) => rate.Latitude && rate.Longitude)
            .map((rate, index) => ({
                id: index,
                name: rate.CompetitorName,
                latitude: rate.Latitude,
                longitude: rate.Longitude,
                rate: rate.Rate,
                distanceMiles: rate.DistanceMiles
            }));
        this.selectedCompetitorRates = unitType.CompetitorMarketRate?.CompetitorRates || [];
        this.selectedCompetitorUnitTypeName = unitType.UnitTypeCode;
        this.sqFt = Array.isArray(unitType.Sqft) ? unitType.Sqft[0] : unitType.Sqft;
        this.selectedFacilityName = this.facilityMapLocation?.FacilityName;
        this.newRent = unitType.CompetitorMarketRate?.NewRent ?? 0;
        this.marketAvg = unitType.CompetitorMarketRate?.AverageOccupiedRent ?? 0;
        this.marketAvgPercentage = this.marketAvg !== 0 ? Math.round(Math.abs(((this.marketAvg - this.newRent) / this.marketAvg) * 100)) : 0;
        this.marketDifferenceText = this.newRent === this.marketAvg ? "at" : (this.newRent < this.marketAvg ? "below" : "above");
        const rates = this.selectedCompetitorRates?.filter(x => x.IsAvailable && x.Rate != null).map(x => Number(x.Rate)) ?? [];
        this.minMarketRate = rates.length ? Math.min(...rates) : 0;
        this.maxMarketRate = rates.length ? Math.max(...rates) : 0;
        this.competitorMapModalRef = this.modalService.show(template, { class: 'modal-lg' });
    }

    getAmenityName(item: any): string[] {
        const result: string[] = [];

        if (item.RequireAutoPay) {
            result.push('Autopay Required');
        }

        if (item.RequirePrepay && item.PrepayMonths > 0) {
            result.push(`Prepay for ${item.PrepayMonths} months`);
        }

        if (item.TimeZoneId && item.TimeZoneName) {
            result.push(`${item.TimeZoneName} - Time Zone`);
        }

        if (item.KeypadZoneId && item.KeypadZone) {
            result.push(`${item.KeypadZone} - KeyPad Zone`);
        }

        if (item.RentRaiseExempt && item.ExemptMonths > 0) {
            result.push(`Rent Raise ${item.ExemptMonths} months`);
        }

        if (item.Merchandise && item.Merchandise.length > 0) {
            item.Merchandise.forEach(m => {
                result.push(`Merchandise - ${m.MerchandiseItem}`);
            });
        }
        return result;
    }

    onlyNumberKey(event) {
        return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
    
    toggleUnitCollapse(unitTypeId: number): void {
        this.expandedUnits[unitTypeId] = !this.expandedUnits[unitTypeId];
        if (!(unitTypeId in this.unitDegrees)) {
            this.unitDegrees[unitTypeId] = this.degree;
        }
        if (this.unitDegrees[unitTypeId] === '180deg') {
            this.unitDegrees[unitTypeId] = '270deg';
        } else {
            this.unitDegrees[unitTypeId] = '180deg';
        }
        const elements = document.getElementsByClassName('rgt_arr_Unit');
        for (let i = 0; i < elements.length; i++) {
            if (elements[i].id === 'ACID' + unitTypeId) {
                (elements[i] as HTMLElement).style.transform = `rotate(${this.unitDegrees[unitTypeId]})`;
            }
        }
    }
    
      isExpanded(unitTypeId: number): boolean {
        return !!this.expandedUnits[unitTypeId];
      }  

      toggleCollapse(itemId: number): void {
        this.expandedMainItems[itemId] = !this.expandedMainItems[itemId];
        if (!(itemId in this.mainDegrees)) {
          this.mainDegrees[itemId] = '270deg';
        }
        this.mainDegrees[itemId] = this.mainDegrees[itemId] === '180deg' ? '270deg' : '180deg';
        const element = document.getElementById('MAINID' + itemId);
        if (element) {
          element.style.transform = `rotate(${this.mainDegrees[itemId]})`;
        }
      }
    
      isMainExpanded(itemId: number): boolean {
        return !!this.expandedMainItems[itemId];
      }
    }
